import { BaseComponent } from '../../components/base-component'
import { parseHTML, replaceNodeChildren } from '../../utils/dom'
import { SidebarComponent } from '../../components/sidebar/sidebar'
import { $el } from 'src/scripts/utils/utils'

export class PickupAvailability extends BaseComponent {
  mountComponent(): void {
    this.fetchAvailability()
  }

  fetchAvailability(): void {
    const url = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = $el('.shopify-section', parseHTML(text))

        this.updateSidebarFromHTML(html)
        this.updateContentFromHTML(html)
      })
      .catch(() => {
        console.log('Error in pickup availability component')
      })
  }

  updateVariantId(newVariantId): void {
    this.dataset.variantId = newVariantId
  }

  updateContentFromHTML(section: HTMLElement): void {
    const content = $el('pickup-availability-content', this)
    const newContent = $el('pickup-availability-content', section)
    replaceNodeChildren(content, newContent)
  }

  updateSidebarFromHTML(section: HTMLElement): void {
    const drawer: SidebarComponent = $el('#pickup-availability-sidebar')

    if (!drawer) {
      return
    }

    const newTemplate: HTMLTemplateElement = $el(
      `[data-sidebar-template="${drawer.id}"]`,
      section,
    )

    if (newTemplate) {
      drawer.updateTemplate(newTemplate)
    }
  }
}
